module.exports = __webpack_public_path__ + "overlook-studios/img/pal-file-system.gif";